<custom-modal
  [header]="'BULK_DELETE_LINE_ITEMS_TITLE'"
  [open]="isOpen"
  [modalClass]="'es-line-items-bulk-delete-modal'"
  [isListenClose]="true"
  (closeClick)="onCancel()"
>
  <p class="modal-intro">{{ "BULK_DELETE_LINE_ITEMS_TEXT" | translate }}</p>

  <button footer-action type="button" class="btn btn-secondary" (click)="onCancel()" [disabled]="isLoading">
    {{ "BUTTON.CANCEL" | translate }}
  </button>
  <button footer-action type="button" class="btn btn-primary ml-2" (click)="onConfirm()" [disabled]="isLoading">
    <span *ngIf="isLoading" class="fa fa-spinner fa-spin mr-1"></span>
    {{ "BUTTON.CONFIRM" | translate }}
  </button>
</custom-modal>
